<div class="evc-confirmation-modal">
  <div class="evc-confirmation-header">{{title}}</div>
  <div class="evc-confirmation-body" [innerHTML]="body2">{{body}}</div>
  <div class="evc-confirmation-button-wrapper">
    <button [class]="'spot-button ' + cancelButton.cls + ' evc-confirmation-button'" (click)="onButtonClick('cancelButton')">{{cancelButton.text}}</button>
    <button [class]="'spot-button ' + button1.cls + ' evc-confirmation-button'" (click)="onButtonClick('button1')">{{button1.text}}</button>
    <button *ngIf="button2" [class]="'spot-button ' + button2.cls + ' evc-confirmation-button'" (click)="onButtonClick('button2')">{{button2.text}}</button>
  </div>
</div>
